var body = $('body'),
    doc = $(document),
    html = $('html'),
    win = $(window),
    wrapperOverlaySlt = '.wrapper-overlay, .close-cart, .close-customer',
    iconNav = $('[data-menu-mb-toogle]'),
    dropdownCart = $('#dropdown-cart'),
    miniProductList = dropdownCart.find('.mini-products-list');

var sidebarCart = $('#sidebar-cart'),
    btnRemove = sidebarCart.find('.btn-remove'),
    sidebarCartNoItems = sidebarCart.find('.cart-empty'),
    sidebarCartHasItems = sidebarCart.find('.mini-products-list'),
    sidebarCartFooter = sidebarCart.find('.cart-footer');

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

ella = {
  initDropdownCart: function () {
    
    var headerMb = $('.header-mb, [data-cart-header-parallax], [data-cart-header-02], [data-cart-header-04], [data-cart-header-supermarket]'),
        cartIcon = headerMb.find('[data-cart-toggle]');

    cartIcon.off('click.initDropdownCartMobile').on('click.initDropdownCartMobile', function (e) {
      e.preventDefault();
      e.stopPropagation();

      html.toggleClass('cart-show');
    });
    
    $('button.icon-search').on('click', function() {
      if ($(window).width() >= 1200) {
      if ($('[name="q"]').val() == '') {
        $('[name="q"]').focus()
        return false
      }
      } else {
       if ($('.mb-search [name="q"]').val() != '') {
        $(this).parents('form').submit() 
       }
       return false
      }
    })
    
    $('.mb-search [name="q"]').on('keyup', function() {
      if ($(this).val() == '') {
       $(this).parents('form').find('.icon-search').removeClass('allow') 
      } else {
        $(this).parents('form').find('.icon-search').addClass('allow') 
      }
    })
    
    var wrapperTopCart = $('.wrapper-top-cart');
        cartIcon = wrapperTopCart.find('[data-cart-toggle]');

    if (cartIcon.length && cartIcon.is(':visible')) {
      if (window.dropdowncart_type == 'click') {
        cartIcon.off('click.toogleDropdownCart').on('click.toogleDropdownCart', function (e) {
          e.preventDefault();
          e.stopPropagation();

          wrapperTopCart.toggleClass('is-open');
          dropdownCart.slideToggle();
        });
      } else {
        cartIcon.hover(function () {
          var customer = $('#dropdown-customer');

          if (customer.is(':visible')) {
            customer.hide();
          };

          if (!wrapperTopCart.hasClass('is-open')) {
            wrapperTopCart.addClass('is-open');
            dropdownCart.slideDown();
          }
        });

        wrapperTopCart.mouseleave(function () {
          if (wrapperTopCart.hasClass('is-open')) {
            wrapperTopCart.removeClass('is-open');
            dropdownCart.slideUp();
          };
        });
      }
    } else {
      dropdownCart.css("display", "");
    }
    
    // $('body').on('click', '.btn-continue', function() {
    //   html.removeClass('cart-show');
    //   return false
    // })
    
    if ($('#contact_form').length) {
      if (location.search == '?contact%5Btags%5D=newsletter&form_type=customer') {
       $('.newsletter-error-modal').show() 
       window.history.replaceState({}, '', "/")
       $('.newsletter-error-modal .close').on('click', function() {
        $('.newsletter-error-modal').hide() 
       })
      }
      if (location.search == '?customer_posted=true') {
       $('.newsletter-success-modal').show() 
       window.history.replaceState({}, '', "/")
       $('.newsletter-success-modal .close').on('click', function() {
        $('.newsletter-success-modal').hide() 
       })
      }
    }
  },
  checkItemsInDropdownCart: function () {
    var cartNoItems = dropdownCart.find('.no-items'),
        cartHasItems = dropdownCart.find('.has-items');



    if (miniProductList.children().length) {
      cartHasItems.show();
      cartNoItems.hide();

      sidebarCartNoItems.hide();
      sidebarCartHasItems.show();
      sidebarCartFooter.show();
    } else {
      cartHasItems.hide();
      cartNoItems.show();

      sidebarCartNoItems.show();
      sidebarCartHasItems.hide();
      sidebarCartFooter.hide();
    };
  },
  closeAllOnMobile: function () {
    body.off('click.close', wrapperOverlaySlt).on('click.close', wrapperOverlaySlt, function (e) {
      e.preventDefault();
      e.stopPropagation();

      html.removeClass('translate-overlay cart-show customer-show sidebar-open options-show');
      $('.close-menu-mb').removeClass('menu-open');

      $('.main-menu.jas-mb-style').css({
        "overflow": ""
      });
      $('.site-nav').find('[data-toggle-menu-mb]').parent().next('.sub-menu-mobile').removeClass('sub-menu-open');
    });
  },
  updateDropdownCart: function () {
    Shopify.getCart(function (cart) {
      ella.doUpdateDropdownCart(cart);
    });
  },
  removeItemDropdownCart: function (cart) {
    var btnRemove = dropdownCart.find('.btn-remove');

    btnRemove.off('click.removeCartItem').on('click.removeCartItem', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var productId = $(this).parents('.item').attr('id');
      productId = productId.match(/\d+/g);

      Shopify.removeItem(productId, function (cart) {
        $("#cart-item-"+productId).remove();
        $("#sidebar-cart-item-"+productId).remove();
        ella.doUpdateDropdownCart(cart);
      });
    });
  },
  doUpdateDropdownCart: function (cart) {
    var template = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><svg aria-hidden="true" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg></a><a class="product-name" href="{URL}">{TITLE}</a><div class="option"><small>{VARIANT}</small></div><div class="cart-collateral"><span class="qtt">{QUANTITY} X </span><span class="price">{PRICE}</span></div></div></li>';

    $('[data-cart-count]').text(cart.item_count);
    dropdownCart.find('.summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
    $('#sidebar-cart').find('.cart-footer .notranslate').html(Shopify.formatMoney(cart.total_price, window.money_format));

    miniProductList.html('');

    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = template;

        item = item.replace(/\{ID\}/g, cart.items[i].id);
        item = item.replace(/\{URL\}/g, cart.items[i].url);
        item = item.replace(/\{TITLE\}/g, cart.items[i].product_title);
        item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title || '');
        item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
        item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, '160x'));
        item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));

        miniProductList.append(item);
      }

      ella.removeItemDropdownCart(cart);
    }

    ella.checkItemsInDropdownCart();
    html.addClass('cart-show');
    // window.Stacked.load(cart)
    
    // if (body.hasClass('template-cart')) {
    //   window.location.reload();
    // }
  },
  changeQuantityAddToCart: function () {
    var buttonSlt = '[data-minus-quantity], [data-plus-quantity]',
        buttonElm = $(buttonSlt);

    doc.on('click', buttonSlt, function (e) {
      e.preventDefault();
      e.stopPropagation();

      var self = $(this),
          input = self.siblings('input[name="quantity"]').length > 0 ? self.siblings('input[name="quantity"]') : self.siblings('input[name="group_quantity"]');



      if (input.length < 1) {
        input = self.siblings('input[name="updates[]"]');
      }

      var val = parseInt(input.val());

      switch (true) {
        case (self.hasClass('plus')):
          {
            val +=1;
            break;
          }
        case (self.hasClass('minus') && val > 0):
          {
            val -=1;
            break;
          }
      }
      input.val(val);

      // update cart
      console.log('click quantity update');
      const updateButton = document.querySelector('.cart-item .update.btn');
      updateButton.click();
    });
  },
  initDropdownSubCategoriesAtSidebar: function () {
    var iconDropdownSlt = '.sidebar-links li.dropdown .icon-dropdown';
    var linkDropdownSlt = '.sidebar-links li.dropdown a';

    body.off('click.toggleSubCategories').on('click.toggleSubCategories', iconDropdownSlt, function (e) {
      e.stopPropagation();

      var self = $(this),
          dropdown = self.next();

      if (self.hasClass('open')) {
        self.removeClass('open');
        dropdown.slideUp();
      } else {
        self.addClass('open');
        dropdown.slideDown();
      };
    })

    body.off('click.linktoCollection').on('click.linktoCollection', linkDropdownSlt, function (e) {
      e.stopPropagation();
    })
  },
  initDropdownCustomer: function() {
    var iconUser = $('[data-user-mobile-toggle]')
    iconUser.off('click.dropdownCustomerMobile').on('click.dropdownCustomerMobile', function (e) {
      e.preventDefault();
      e.stopPropagation();

      html.addClass( 'customer-show');
    });
  },
  initDropdownColFooter: function () {
    var footerTitle = $('.site-footer .dropdow-mb');

    if (window.innerWidth < 768) {
      if (footerTitle.length) {
        footerTitle.off('click.slideToggle').on('click.slideToggle', function () {
          $(this).next().slideToggle();
          $(this).toggleClass('open');
        });
      }
    } else {
      footerTitle.next().css({
        "display": ""
      });
    }
  },
  showHideMenuMobile: function () {
    if (iconNav.length && iconNav.is(':visible')) {
      iconNav.off('click.showMenuMobile').on('click.showMenuMobile', function (e) {
        e.preventDefault();
        e.stopPropagation();

        html.toggleClass('translate-overlay');
        $('.close-menu-mb').toggleClass('menu-open');

        $('.main-menu.jas-mb-style').css({
          "overflow": ""
        });
        $('.site-nav').find('[data-toggle-menu-mb]').parent().next('.sub-menu-mobile').removeClass('sub-menu-open');
      })
    };
  },
  initToggleSubMenuMobile: function () {
    var mainMenu = $('.main-menu.jas-mb-style'),
        siteNav = $('.site-nav'),
        iconDropdown = siteNav.find('[data-toggle-menu-mb]');

    iconDropdown.off('click.dropdownMenu').on('click.dropdownMenu', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var curParent = $(this).parent(),
          curMenu = curParent.next('.sub-menu-mobile');

      if (curMenu.hasClass('sub-menu-open')) {
        curMenu.removeClass('sub-menu-open');
      } else {
        curMenu.addClass('sub-menu-open').css({
          "overflow": ""
        });
        mainMenu.animate({
          scrollTop: 0
        }, 0);
        mainMenu.css({
          "overflow": "hidden"
        });
      };
    });

    ella.linkClickToggleSubMenuMobile(mainMenu);
  },
  linkClickToggleSubMenuMobile: function (mainMenu) {
    var menuMobile = $('.site-nav .dropdown'),
        iconDropdown = menuMobile.find('[data-toggle-menu-mb]'),
        menuMobileLabel = $('.sub-menu-mobile .menu-mb-title');

    if (iconDropdown.length && iconDropdown.is(':visible')) {
      menuMobile.off('click.current').on('click.current', function (e) {
        e.stopPropagation();

        $(this).children('.sub-menu-mobile').addClass('sub-menu-open').css({
          "overflow": ""
        });
        mainMenu.animate({
          scrollTop: 0
        }, 0);
        mainMenu.css({
          "overflow": "hidden"
        });
      });

      menuMobile.find('.menu__moblie').on('click', function (e) {
        e.stopPropagation();
      });

      menuMobileLabel.off('click.closeMenu').on('click.closeMenu', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if($(this).parent().hasClass('bg')) {
          $(this).parent().parent().removeClass('sub-menu-open');
        }else {
          $(this).parent().removeClass('sub-menu-open');
        };

        if (!$(this).closest('.menu-lv-2').length) {
          mainMenu.css({
            "overflow": ""
          });
        };
      })
    };
  },
  updateSearchaniseWidget: function() {
    $('.mb-search input, .mb-search button').on('touchstart', function() {
      setTimeout(function() {
        if ($('.snize-ac-results-mobile').length && !$('.snize-ac-results-mobile .snize-close-button + form .search-icon').length) {
           $('.snize-ac-results-mobile .snize-close-button + form').append('<button class="search-icon" type="submit"></button>')
        }
      }, 100)
    })
  },
  
  discountBox: function() {
    
    renderBox = function(res) {
      $html = $(res)
      reduction = $html.find('.tags-list .reduction-code__text').first();
      if (reduction.length) {
        $('.discount-box').hide()
        $('.total.subtotal.discounted .discount-text').text(reduction.text())

        $.ajax({
          url: '/discount/' + reduction.text()
        })
        before = parseFloat($('.total.subtotal .price').text().replace('$', '').replace(/,/g, '')) * 100
        after = parseFloat($html.find('[data-checkout-subtotal-price-target]').attr('data-checkout-subtotal-price-target'))

        tr_reduction_wrapper = $html.find('.total-line--reduction')
        discount_text = tr_reduction_wrapper.find('.order-summary__emphasis').text()
        
        if (discount_text) {
          discount_calc = parseFloat(discount_text.replace('- $', '').replace('$','').replaceAll(' ', '').replace(/,/g, '')) * 100;
          after -= discount_calc
        }

        discount = (before - after) / 100
        $('.total.subtotal.discounted .price').text('-$' + numberWithCommas(discount.toFixed(2)))
        $('.total.subtotal').addClass('active')
        calc = (after/4)
        total = '$' + numberWithCommas((after/100).toFixed(2))
        $('.total.final .price').text(total)

        if (calc < 100) {
          $('.paypal-pay-in-4').hide()
        } else {
          $('.paypal-pay-in-4').show()
          $('#pay4').text('$' + numberWithCommas((calc/100).toFixed(2)))
        }

        $('.remove-discount').on('click', function() {
          window.history.replaceState('', '', location.pathname)
          $.ajax({
            url: '/checkout?discount=+',
            success: function(data, textStatus, request) {
              $.get(request.getResponseHeader('content-location'))
              location.reload()
            }
          })
          $('.discount-box').show()
          $('.total.subtotal').removeClass('active')
          $('.total.final .price').text($('.total.subtotal:not(.discounted) .price').text())
          return false
        })
      } else {
        $.ajax({
          url: '/discount/+'
        })
        $('.discount-box').show()
        $('.total.subtotal').removeClass('active')
        if (location.search.indexOf('applied=discount') != -1) {
          $('.discount-error').show()
          window.history.replaceState('', '', location.pathname)
        }
      }
    }
    
    if ($('body.template-cart').length) {
      $.ajax({
        url: '/checkout',
        success: function(data, textStatus, request) {
          if (request.getResponseHeader('content-location')) {
            $.ajax({
              url: request.getResponseHeader('content-location'),
              success: function(res) {
                renderBox(res)
              }
            })
          } else {
            renderBox(request.responseText)
          }
        }
      })
      
      $('.discount-box a').on('click', function() {
        $('.discount-box').toggleClass('opened')
        return false
      })
      
      $('.discount-input button').on('click', function() {
          if ($('.discount-input input').val() != '') {

            $.ajax({
              url: '/discount/' + $('.discount-input input').val(),
              success: function(data, textStatus, request) {
                location.href = '/checkout';
              }
            });
          }
          return false
      });

      $('[js-checkout-buttons]').on('click', function(e) {
        if ($('.discount-input input').val() != '' || $('.discount-input input').is(":focus")) {
          e.preventDefault();
          if ($('.discount-input input').val() != '') {
            
            $.ajax({
              url: '/discount/' + $('.discount-input input').val(),
              success: function(data, textStatus, request) {
                location.href = '/checkout';
              }
            });
          }
          return false
        }
      })

      function showDiscountError(message) {
        const errorBox = $('<div class="discount-error"></div>').text(message);
        $('.discount-input').append(errorBox);

        setTimeout(() => {
          errorBox.fadeOut(300, function () {
            $(this).remove();
          });
        }, 4000);
      }

      /**
       * Synchronizes the locally stored discount code (`applied-discount`) with the current cart state.
       *
       * - Fetches the cart via `/cart.js` and checks if the saved discount code is still active.
       * - If the discount code stored in `localStorage` is no longer present in the cart,
       *   it removes the key `applied-discount` from `localStorage`.
       *
       * Side effects:
       * - May remove `applied-discount` from `localStorage`.
       * - Logs a warning if cart data cannot be fetched.
       *
       * @function
       */
      function syncDiscountWithLocalStorage() {
        const appliedDiscountKey = 'applied-discount';
        const appliedDiscountFromLocalStorage = localStorage.getItem(appliedDiscountKey);
        // Normalize the value from localStorage. Some browsers or legacy code may store the string "undefined".
        // Convert it to null to represent the absence of a discount code.
        const normalizeLocalStorageValue = (value) => (value === "undefined" || value === null) ? null : value;
        let savedDiscount = normalizeLocalStorageValue(appliedDiscountFromLocalStorage);

        $.getJSON('/cart.js')
                .done(function(cart) {
                  const activeCodes = (cart.discount_codes || []).map(discountCode => discountCode.code.toLowerCase());
                  if (savedDiscount) {
                    if (activeCodes.length === 0) {
                      localStorage.removeItem(appliedDiscountKey);
                    } else if (activeCodes.length > 0) {
                      localStorage.setItem(appliedDiscountKey, activeCodes[0]);
                    }
                  } else {
                    if (activeCodes.length > 0) {
                      localStorage.setItem(appliedDiscountKey, activeCodes[0]);
                    }
                  }
                })
                .fail(function() {
                  console.warn('[Discount Sync] Failed to fetch cart data. Unable to verify discount code status.');
                });
      }

      if ($('body').hasClass('template-cart')) {
        syncDiscountWithLocalStorage();
      }

      $('.cart-form').on('submit', function (e) {
        const discountInput = $('.discount-input input');
        const discountInputValue = discountInput.val();
        const $activeElement = $(document.activeElement);

        const isCheckoutButton =
                $activeElement.attr('name') === 'checkout' ||
                $activeElement.val() === 'checkout';

        const savedDiscount = localStorage.getItem('applied-discount');

        if (discountInputValue !== '' || discountInput.is(':focus')) {
          e.preventDefault();

          if (discountInputValue !== '') {
            localStorage.setItem('applied-discount', discountInputValue);

            $.ajax({
              url: '/discount/' + encodeURIComponent(discountInputValue),
              success: function () {
                $.getJSON('/cart.js')
                        .done(function (cart) {
                          const code = cart.discount_codes?.[0]?.code;
                          if (code) {
                            location.href = '/checkout?discount=' + code;
                          } else {
                            showDiscountError('Discount not applied. Please check the code.');
                          }
                        })
                        .fail(function () {
                          showDiscountError('Failed to update cart. Please try again.');
                        });
              },
              error: function (data, textStatus, request) {
                showDiscountError('Failed to apply discount. Please check your connection or try again later.');
              }
            });
          }

          return false;
        }

        if (isCheckoutButton && savedDiscount) {
          e.preventDefault();
          $.getJSON('/cart.js', function (cart) {
            const code = cart.discount_codes?.[0]?.code || savedDiscount;
            location.href = '/checkout?discount=' + code;
          });

          return false;
        }

        return true;
      });

    }
  }
}

ella.initDropdownCart()
ella.checkItemsInDropdownCart()
ella.removeItemDropdownCart()
ella.closeAllOnMobile()
ella.changeQuantityAddToCart()
ella.initDropdownSubCategoriesAtSidebar()
ella.initDropdownCustomer()
ella.initDropdownColFooter()
ella.showHideMenuMobile()
ella.initToggleSubMenuMobile()
ella.updateSearchaniseWidget()
ella.discountBox()